import { render } from "./PriceEditor.vue?vue&type=template&id=5288cd06&scoped=true"
import script from "./PriceEditor.vue?vue&type=script&lang=js"
export * from "./PriceEditor.vue?vue&type=script&lang=js"

import "./PriceEditor.vue?vue&type=style&index=0&id=5288cd06&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5288cd06"]])

export default __exports__